import { Component } from "react"
import PropTypes from "prop-types"
import find from "lodash/find"
import isEmpty from "lodash/isEmpty"
import { put, post, del } from "shared/lib/api"
import { rejectedXHRPromiseLogger } from "shared/lib/xhr_promise"
import sluggify from "shared/lib/sluggify"
import stepFieldsValidator from "../shared/step_fields_validator"
import fieldTypes from "partners/components/shared/trigger_field_types"
import displayFlash from "partners/scripts/display_flash"
import classNames from "classnames"
import Modal from "shared/components/modal"

const MAX_INDEX_OF_TEXT_FIELD_TYPES = 5
// as defined https://github.com/IFTTT/ifttt_front_end/blob/master/lib/ifttt/developers/trigger_field_types.rb

export default class TriggerFieldsForm extends Component {
  state = {
    populatedStaticValues: this.props.populator_values || [],
    selectedTriggerFieldType: this.props.trigger_field_type,
    regexValue: this.props.regex_value,
    regexErrorMessage: this.props.regex_error_message,
    helperText: this.props.helper_text,
    slug: this.props.slug,
    name: this.props.name,
    shareable: this.props.shareable ? "true" : "false",
    id: this.props.id,
    destructive: this.props.destructive,
    errors: {},
    destructiveMethod: null,
  }

  componentDidMount() {
    if (this.state.selectedTriggerFieldType === undefined) {
      this.show(".group100")
    } else {
      const field = this.traverseItemId(this.state.selectedTriggerFieldType)
      const item = find(field.items, el => el.id == this.state.selectedTriggerFieldType)
      const fieldParent = this.traverseItemId(field.parent)
      const parentItem = find(fieldParent.items, el => el.id == field.parent)
      const rootField = this.traverseItemId(fieldParent.parent)
      const rootItem = find(rootField.items, el => el.id == fieldParent.parent)

      const parentSelect = document.querySelector(`#${fieldParent.slug} select`)
      parentSelect.value = parentItem.next
      document.querySelector(`#${rootField.slug} select`).value = rootItem.next

      document.querySelector(`[data-displayfield='${item.value}']`).selected = true

      this.displayCombination(parentSelect)
      this.displayCombination(document.querySelector(`#${field.slug} select`))
    }

    this.handleAddTriggerFieldButtonDisplay()
  }

  componentWillUnmount() {
    this.handleAddTriggerFieldButtonDisplay()
  }

  handleRegexChange = event => {
    this.setState({ regexValue: event.target.value })
  }

  handleRegexMessageChange = event => {
    this.setState({ regexErrorMessage: event.target.value })
  }

  handleSlugChange = event => {
    this.setState({ slug: event.target.value })
  }

  handleNameBlur = () => {
    if (this.state.slug === undefined && this.state.name) {
      this.setState({ slug: sluggify(this.state.name) })
    }
  }

  handleHelperTextChange = event => {
    this.setState({ helperText: event.target.value })
  }

  handleNameChange = event => {
    this.setState({ name: event.target.value })
  }

  handleFieldTypeChange = event => {
    this.displayCombination(event.target)
  }

  handleShareableChange = event => {
    this.setState({ shareable: event.target.checked ? "false" : "true" })
  }

  rawType(field) {
    const rType = document.querySelector(`#${field.slug} select option:checked`).dataset.displayfield
    if (rType === undefined) {
      return "none"
    } else {
      return rType
    }
  }

  displayCombination(el) {
    const next = el.value
    const selected = el.querySelector("option:checked")
    const extraItem = selected.dataset.displayfield
    const selectedItem = selected.dataset.itemId
    const openerField = this.traverseItemId(selectedItem)

    if (next != "none") {
      const field = this.findBySlug(next)

      this.hide(".trigger-option")
      this.show(
        ".group0",
        `#${field.slug}`,
        `.group${openerField.parent}`,
        `.group${field.parent}`,
        ".dropdown-static-fields"
      )

      // this is for previously selected options

      if (this.rawType(field) != "text_regex") {
        this.hide(".regex-option")
      }

      if (this.rawType(field).indexOf("_dynamic") == -1) {
        this.hide(".dynamic-option", ".dynamic-validation")
      }
      if (
        !["dropdown_static", "checkbox_static"].includes(this.rawType(field))
      ) {
        this.hide(".dropdown-static-fields")
      }
      if (this.rawType(field) == "none") {
        // this has 2 more dependencies
        const locationType = document.querySelector(`#${next} select`).value
        const locationValidation = this.rawType(this.findBySlug(locationType))
        this.show(`#${locationType}`)
        if (locationValidation == "dropdown_dynamic") {
          this.show(".dynamic-option")
        } else if (locationValidation.indexOf("_dynamic") != -1) {
          this.show(".dynamic-validation")
        }
        if (locationValidation == "text_regex") {
          this.show(".regex-option")
        }
      }
    } else {
      this.show(".group0")
      for (let el of fieldTypes) {
        if (el.weight > openerField.weight) {
          this.hide(`#${el.slug}`)
        }
      }
      this.displayExtraItem(extraItem)
    }
    this.setState({ selectedTriggerFieldType: this.selectedTriggerFieldId() })
  }

  displayExtraItem(extraItem) {
    if (extraItem == "text_regex") {
      this.hide(
        ".dropdown-static-fields",
        ".dynamic-option",
        ".dynamic-validation"
      )
      this.show(".regex-option")
    } else if (
      [
        "dropdown_dynamic",
        "dropdown_dynamic_double",
        "checkbox_dynamic",
      ].includes(extraItem)
    ) {
      this.hide(
        ".dropdown-static-fields",
        ".regex-option",
        ".dynamic-validation"
      )
      this.show(".dynamic-option")
    } else if (extraItem.indexOf("_dynamic") != -1) {
      this.hide(".dropdown-static-fields", ".regex-option", ".dynamic-option")
      this.show(".dynamic-validation")
    } else if (["dropdown_static", "checkbox_static"].includes(extraItem)) {
      this.hide(".regex-option", ".dynamic-option", ".dynamic-validation")
      this.show(".dropdown-static-fields")
    } else {
      this.hide(
        ".dynamic-option",
        ".regex-option",
        ".dynamic-validation",
        ".dropdown-static-fields"
      )
    }
  }

  fieldTypeOption(item) {
    const next = item.next !== undefined ? item.next : "none"
    return (
      <option
        key={item.id}
        data-item-id={item.id}
        data-hide-next={item.hide_next}
        data-displayfield={item.value}
        value={next}
      >
        {item.name}
      </option>
    )
  }

  optionDivs(field, index) {
    const options = field.items.map(item => this.fieldTypeOption(item))
    const display = field.parent == 0 ? "" : "none"
    const classNames = `field trigger-option group${field.parent}`

    return (
      <div
        key={index}
        id={field.slug}
        className={classNames}
        style={{ display }}
      >
        <div className="label">
          <label>{field.name}</label>
        </div>
        <div className="input">
          <select onChange={this.handleFieldTypeChange}>{options}</select>
        </div>
      </div>
    )
  }

  fieldTypeWillChangeDestructively() {
    if (
      this.state.selectedTriggerFieldType <= MAX_INDEX_OF_TEXT_FIELD_TYPES &&
      this.props.trigger_field_type <= MAX_INDEX_OF_TEXT_FIELD_TYPES
    ) {
      return false
    } else {
      return (
        this.props.trigger_field_type !== this.state.selectedTriggerFieldType
      )
    }
  }

  payLoad() {
    return {
      authenticity_token: this.props.authenticity_token,
      partner_trigger_field: {
        trigger_field_type: this.state.selectedTriggerFieldType,
        populator_values: this.state.populatedStaticValues,
        regex_value: this.state.regexValue,
        regex_error_message: this.state.regexErrorMessage,
        helper_text: this.state.helperText,
        slug: this.state.slug,
        name: this.state.name,
        shareable: this.state.shareable,
        module_name: this.props.service_slug,
        trigger_id: this.props.trigger_id,
      },
    }
  }

  findBySlug(slug) {
    return find(fieldTypes, el => el.slug == slug)
  }

  verifyDestructiveChange(destructiveMethod) {
    if (this.fieldTypeWillChangeDestructively() && this.state.destructive) {
      this.setState({ destructiveMethod })
    } else {
      this[destructiveMethod]()
    }
  }

  handleClickSave = event => {
    event.preventDefault()

    let _errors = stepFieldsValidator(this.payLoad().partner_trigger_field)

    this.setState({ errors: _errors })

    if (!isEmpty(_errors)) {
      displayFlash(
        "Could not save this trigger field. Please check your data!",
        "error"
      )
    } else {
      this.verifyDestructiveChange("handleSave")
    }
  }

  handleSave = () => {
    this.setState({ destructiveMethod: null })

    let url = `/services/${this.props.service_slug}/triggers/${this.props.trigger_id}/trigger_fields`
    let verb = "created"
    let method = post

    if (this.props.id !== undefined) {
      url = `/services/${this.props.service_slug}/triggers/${this.props.trigger_id}/trigger_fields/${this.props.slug}`
      verb = "updated"
      method = put
    }

    method(url, this.payLoad(), { Accept: "text/javascript" })
      .then(() => {
        displayFlash(`Trigger field ${verb}`)
      })
      .catch(
        rejectedXHRPromiseLogger(({ response }) => {
          displayFlash(
            "There has been an error saving the trigger field.",
            "error"
          )
          response.then(({ errors }) => this.parseErrors(errors || {}));
        })
      )
  }

  handleClickDeleteTriggerField = event => {
    event.preventDefault()
    this.setState({ destructiveMethod: "handleDeleteTriggerField" })
  }

  handleDeleteTriggerField = () => {
    this.setState({ destructiveMethod: null })

    let url = `/services/${this.props.service_slug}/triggers/${this.props.trigger_id}/trigger_fields/${this.props.slug}`
    del(url)
      .then(() => {
        displayFlash("Trigger field deleted")
      })
      .catch(
        rejectedXHRPromiseLogger(() => {
          displayFlash(
            "There has been an error deleting the trigger field.",
            "error"
          )
        })
      )
  }

  traverseItemId(itemId) {
    for (let el of fieldTypes) {
      let item = find(el.items, el => el.id == itemId)
      if (item !== undefined) {
        return el
      }
    }
  }

  populateStaticValues = (index, type, value) => {
    let rows = this.state.populatedStaticValues
    rows[index][type] = value

    this.setState({ populatedStaticValues: rows })
  }

  hide() {
    for (let el of arguments) {
      document.querySelectorAll(el).forEach(sel => (sel.style.display = "none"))
    }
  }

  show() {
    for (let el of arguments) {
      document.querySelectorAll(el).forEach(sel => (sel.style.display = "block"))
    }
  }

  selectedTriggerFieldId() {
    let weightSelected = 0
    let selected = null
    for (let field of fieldTypes) {
      if (field.weight >= weightSelected && document.querySelector(`#${field.slug}`).style.display == "block") {
        // has to work even if not selected by user - in case it's default
        weightSelected = field.weight
        selected = field
      }
    }
    const itemId = document.querySelector(`#${selected.slug} option:checked`).dataset.itemId;
    return Number(itemId)
  }

  handleClickAddStaticField = () => {
    let { populatedStaticValues } = this.state
    populatedStaticValues.push({ name: "", value: "" })

    this.setState({
      populatedStaticValues,
    })
  }

  handleClickRemoveStaticField = index => {
    let { populatedStaticValues } = this.state

    if (populatedStaticValues.length >= 2) {
      populatedStaticValues.splice(index, 1)
      this.setState({
        populatedStaticValues,
      })
    }
  }

  parseErrors(errors) {
    let _errors = {}
    errors.forEach(error => {
      return (_errors[error.attribute] = error.message)
    })
    this.setState({ errors: _errors })
  }

  displayError(str) {
    return <span className="error-message">Error: {str}</span>
  }

  displayDeleteOption() {
    if (this.props.id !== undefined && this.props.platformUnpublished)
      return (
        <a
          href=""
          className="secondary-action delete link-standalone"
          onClick={this.handleClickDeleteTriggerField}
        >
          Delete
        </a>
      )
  }

  handleAddTriggerFieldButtonDisplay() {
    const triggerFieldCount = document.querySelectorAll("ul#input-list > li").length

    if (this.props.trigger_type === "feed" && triggerFieldCount > 0) {
      document.querySelector(".trigger-sections .button-tertiary.add-field").classList.add("visibility-hidden")
    } else {
      document.querySelector(".trigger-sections .button-tertiary.add-field").classList.remove("visibility-hidden")
    }
  }

  renderStaticField = (index, name, value) => {
    const keyName = `key-${index}`
    const valueName = `value-${index}`
    return (
      <div className="dropdown-static-fields-row" key={keyName}>
        <div className="dropdown-static-field">
          <input
            type="text"
            name={keyName}
            onChange={e => {
              this.populateStaticValues(index, "name", e.target.value)
            }}
            value={name}
            className="key"
          />
        </div>
        <div className="dropdown-static-field">
          <input
            type="text"
            name={valueName}
            onChange={e => {
              this.populateStaticValues(index, "value", e.target.value)
            }}
            value={value}
            className="value"
          />
        </div>
        <div className="delete-row">
          <span
            onClick={() => {
              this.handleClickRemoveStaticField(index)
            }}
            className="remove-element"
          >
            x
          </span>
        </div>
      </div>
    )
  }

  onClose = () => {
    this.setState({ destructiveMethod: null })
  }

  verifyDestructiveChangeModal() {
    return (
      <Modal
        show={this.state.destructiveMethod !== null}
        closeListener={this.onClose}
        headerText={
          this.state.destructiveMethod === "handleSave"
            ? "Are you sure you want to change the trigger field type?"
            : "Are you sure you want to PERMANENTLY delete this trigger field?"
        }
        includeCloseX={false}
      >
        <div>
          <p>All Applets using this trigger will be deleted.</p>
          <button
            type="submit"
            onClick={this[this.state.destructiveMethod]}
            className="button-tertiary"
          >
            Yes, save these changes
          </button>
          <p className="note pointer" onClick={this.onClose}>
            Cancel
          </p>
        </div>
      </Modal>
    )
  }

  render() {
    const optionDivs = fieldTypes.map((item, index) =>
      this.optionDivs(item, index)
    )

    const populatorEndpointValue = this.state.slug
      ? this.props.populatorTemplate.replace(/{{slug}}/, this.state.slug)
      : "Please provide a key name for this trigger field"

    const validatorEndpointValue = this.state.slug
      ? this.props.validatorTemplate.replace(/{{slug}}/, this.state.slug)
      : "Please provide a key name for this trigger field"

    const populatorErrors = this.state.errors.populator || this.state.errors.populator_values

    return (
      <>
        {this.verifyDestructiveChangeModal()}
        <form className="service-edit form">
          <section>
            <div className="fieldset list-item-form">
              <div className="field">
                <div className="label">
                  <label htmlFor="partner_trigger_field_name">Label</label>
                </div>
                <div className="input">
                  <input
                    type="text"
                    name="partner_trigger_field[name]"
                    id="partner_trigger_field_name"
                    value={this.state.name}
                    onChange={this.handleNameChange}
                    onBlur={this.handleNameBlur}
                  />
                </div>

                <p className="note">
                  Include a leading statement — use a question where possible
                  {this.state.errors.name
                    ? this.displayError(this.state.errors.name)
                    : ""}
                </p>
              </div>

              <div className="field">
                <div className="label">
                  <label htmlFor="partner_trigger_field_helper_text">
                    Optional helper text
                  </label>
                </div>
                <div className="input">
                  <input
                    type="text"
                    name="partner_trigger_field[helper_text]"
                    id="partner_trigger_field_helper_text"
                    value={this.state.helperText}
                    onChange={this.handleHelperTextChange}
                  />
                </div>
                <p className="note">
                  Markdown-style links allowed{" "}
                  {this.state.errors.helper_text
                    ? this.displayError(this.state.errors.helper_text)
                    : ""}
                </p>
              </div>

              <div
                className={classNames("field", {
                  "visibility-hidden": this.props.trigger_type === "feed",
                })}
              >
                <div className="label">
                  <label htmlFor="partner_trigger_field_slug">Key name</label>
                </div>
                <div className="input">
                  <input
                    type="text"
                    name="partner_trigger_field[slug]"
                    id="partner_trigger_field_slug"
                    value={this.state.slug}
                    onChange={this.handleSlugChange}
                  />
                </div>
                <p className="note">
                  In snake_case
                  {this.state.errors.slug
                    ? this.displayError(this.state.errors.slug)
                    : ""}
                </p>
              </div>

              <div className="field">
                <div className="label">
                  <label htmlFor="partner_trigger_field_shareable">
                    Private
                  </label>
                </div>
                <div className="input">
                  <label className="checkbox">
                    <input
                      type="checkbox"
                      name="partner_trigger_field[shareable]"
                      id="partner_trigger_field_shareable"
                      defaultChecked={this.state.shareable === "false"}
                      onChange={this.handleShareableChange}
                    />

                    <span />
                    <span>
                      <span className="checkbox-body">
                        Keep the contents of this trigger field private.
                      </span>
                    </span>
                  </label>
                </div>
                <p className="note">
                  Does this field require an input that is user-specific (e.g.
                  personal device, email address, user profile)? If so, mark as
                  private so this field is left blank in published Applets.
                  Note: ingredients are not available for use in private fields.
                </p>
              </div>

              <div
                className={classNames({
                  "visibility-hidden": this.props.trigger_type == "feed",
                })}
              >
                {optionDivs}

                <div id="regex">
                  <div
                    className="fieldset regex-option trigger-option group500"
                    style={{ display: "none" }}
                  >
                    <div className="field">
                      <div className="label">
                        <label>Custom regex</label>
                      </div>
                      <div className="input">
                        <input
                          type="text"
                          name="regex_value"
                          defaultValue={this.state.regexValue}
                          onChange={this.handleRegexChange}
                        />
                      </div>
                      <p className="note">
                        {this.state.errors.regex_value
                          ? this.displayError(this.state.errors.regex_value)
                          : ""}
                      </p>
                    </div>
                    <div className="field">
                      <div className="label">
                        <label>Regex error message</label>
                      </div>
                      <div className="input">
                        <input
                          type="text"
                          name="regex_error_message"
                          defaultValue={this.state.regexErrorMessage}
                          onChange={this.handleRegexMessageChange}
                          placeholder="Your input may not include capital letters…"
                        />
                      </div>

                      <p className="note">
                        Keep error messages friendly, helpful, and short.
                        {this.state.errors.regex_error_message
                          ? this.displayError(
                              this.state.errors.regex_error_message
                            )
                          : ""}
                      </p>
                    </div>
                  </div>
                </div>

                <div id="dynamic-validations">
                  <div
                    className="fieldset dynamic-validation trigger-option group500"
                    style={{ display: "none" }}
                  >
                    <div className="field">
                      <div className="label">
                        <label>
                          API endpoint to validate the trigger field
                        </label>
                      </div>
                      <div className="input">
                        <input
                          type="text"
                          value={validatorEndpointValue}
                          disabled={!this.state.slug}
                          data-copy-field-on-click="Dynamic validation endpoint"
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div id="dynamic-options">
                  <div
                    className="fieldset dynamic-option trigger-option group200 group400"
                    style={{ display: "none" }}
                  >
                    <div className="field">
                      <div className="label">
                        <label>
                          API endpoint to populate the trigger field
                        </label>
                      </div>
                      <div className="input">
                        <input
                          type="text"
                          value={populatorEndpointValue}
                          disabled={!this.state.slug}
                          data-copy-field-on-click="Dynamic options endpoint"
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="field">
                  <label />
                  <div className="input">
                    <div
                      className="dropdown-static-fields child-option trigger-option"
                      style={{ display: "none" }}
                    >
                      <div className="dropdown-static-fields-row">
                        <div className="dropdown-static-field label">
                          <label>Label</label>
                        </div>
                        <div className="dropdown-static-field label">
                          <label>Value</label>
                        </div>
                        <div className="delete-row">&nbsp;</div>
                      </div>
                      {this.state.populatedStaticValues.map((value, key) =>
                        this.renderStaticField(key, value.name, value.value)
                      )}
                      <span
                        onClick={this.handleClickAddStaticField}
                        className="button-tertiary"
                      >
                        Add an option
                      </span>
                      {populatorErrors ? this.displayError(populatorErrors) : ""}
                    </div>
                  </div>
                </div>
              </div>

              <div className="actions">
                <div className="action-left">{this.displayDeleteOption()}</div>
                <div className="action-right">
                  <a
                    href=""
                    className="secondary-action"
                    data-load-form-async="trigger-fields"
                    data-action="cancel-form"
                  >
                    Cancel
                  </a>
                  <button
                    className="button-secondary"
                    onClick={this.handleClickSave}
                    data-disable-with="Saving…"
                    disabled={!this.props.platformUnpublished}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </section>
        </form>
      </>
    )
  }
}

TriggerFieldsForm.propTypes = {
  service_slug: PropTypes.string.isRequired,
  authenticity_token: PropTypes.string.isRequired,
  trigger_id: PropTypes.number.isRequired,
  trigger_type: PropTypes.string.isRequired,
  id: PropTypes.number,
  slug: PropTypes.string,
  name: PropTypes.string,
  shareable: PropTypes.bool,
  helper_text: PropTypes.string,
  populator_values: PropTypes.array,
  regex_value: PropTypes.string,
  regex_error_message: PropTypes.string,
  trigger_field_type: PropTypes.number,
  field_type: PropTypes.string,
  destructive: PropTypes.bool,
  platformUnpublished: PropTypes.bool,
  populatorTemplate: PropTypes.string.isRequired,
  validatorTemplate: PropTypes.string.isRequired,
}

TriggerFieldsForm.defaultProps = {
  shareable: true,
  populator_values: [],
  destructive: false,
}
